import { Injectable } from '@angular/core';
import { AppComponent } from '../app/app.component';
//import 'rxjs/add/operator/map';

/*
  Generated class for the ApplicationConstants provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ApplicationConstants {
  // public appURL: string = "";
  public appFolder: string = "";
  public appComp: AppComponent;

  constructor() {
    this.appFolder = window.location.pathname;  // "../../";  //                         
  }
  
  public mainURL: string = "./acct_ws/";  // "http://localhost/acct_ws/";  //                                             
  public generalFile: string = this.mainURL + "general.php";
  public functionFile: string = this.mainURL + "acct_function.php";
  public saleFuncFile: string = this.mainURL + "sale_function.php";
  public generatePDF: string = this.mainURL + "print_generator.php";
  public generateInvoice: string = this.mainURL + "invoice_generator.php";
  public generateBarcode: string = this.mainURL + "barcode_generator.php";
  public generateThermalInvoice: string = this.mainURL + "thermal_invoice_generator.php";
  public statementPrint: string = this.mainURL + "statement_print.php";
  public contractPrint: string = this.mainURL + "contract_print.php"; 
  public ticketPrint: string = this.mainURL + "ticket_print.php";
  public uploadFile: string = this.mainURL + "upload_file.php";
  public tourismFile: string = this.mainURL + "tourism_function.php";
  public acctFile: string = this.mainURL + "acct.php";
  public generateComInvoice: string = this.mainURL + "com_invoice_generator.php";
  public generatePassport:string = this.mainURL + "passport_generator.php";
  public userManualURL: string = "https://progconsult.com/user_manual/user_manual.html";  // this.mainURL + "/user_manual/user_manual.html"; // 
  public clearHistoryURL: string = "https://progconsult.com/user_manual/clear_history.pdf";


  //public appURL:string = ""; //"http://localhost/dist/"; //  
  // "http://localhost/dist/"; // "/dist/"; //

  public user_lang = "ar"; //default langauge is Arabic
  public langList = [{ name: "العربية", code: "ar" }, { name: "English", code: "en" }];

  public main_menu;
  public sub_menu_all;
  public cost_center = 0;
  public company_id = '1';
  public branch_id = '1';

  public user_info = {
    company_id: '', branch_id: '', casher_acct_number: '', user_name: '',
    user_full_name: '', is_counter: '', role: '', user_id: ''
  };
  // public sales_acct = { acct_number: '702001', tax_acct: '403001' };
  public ret_sales_acct = '702002';
  // public ret_purch_acct = '803002';
  // public trans_acct = '802001';
  public param: any = [];
  // public exp_acct = '801001';
  public isLogged: boolean = false;
  public isinit: boolean = false;
  public app_version = '2025-06-16';
  public isMaint: boolean = true;

  public views: Array<any> = [];

  public ADD_AUTH = 'add_auth';
  public EDIT_AUTH = 'edit_auth';
  public VIEW_AUTH = 'view_auth';
  public DELETE_AUTH = 'delete_auth';

  public system_expiry_date = '';
  public system_expired: boolean = false;
  public system_will_expire: boolean = false;
  public branch_exist: boolean = true;

  public machine_no = '1';

  public user_branch_info = {
    'user_branch_id': '0', 'user_branch_name': '', 'user_branch_name_en': '',
    'user_store_id': '0', 'user_store_name': '', 'user_store_name_en': ''
  };

  public acct_type_config: any = [];
  public main_acct_config: any = [];
  // public customerList: any = [];
  // public counterCustList: any = [];

  public business_cycle = { 'start_date' : new Date('2024-01-01'), 'end_date' : new Date('2124-12-31') };
}
